import React from 'react'
import './Blog.css'
import Article from './Article/Article'

const Blog = () => {

  return (
    <section className='Blog'>
      <div className='container'>
        <div className='row'>
          <div className='col'>
            <div className='Blog-descr'>
              <h2>Blog</h2>
              <a href='/'>see all <span className='arrow'></span></a>
            </div>
          </div>
        </div>
        <div className='row'>
          <Article
            title="Standardization of color schemes through the eyes of a programmer"
            text="Let’s try to figure out how designers use colors in UI and how the whole thing
            can be standardized without restricting designers"
          />
          <Article
            title="Standardization of color schemes through the eyes of a programmer"
            text="Let’s try to figure out how designers use colors in UI and how the whole thing
            can be standardized without restricting designers"
          />
        </div>
      </div>
    </section>
  )
}

export default Blog